export enum WarningType {
  WARNING = 'warning',
  INFO = 'info',
}
